import * as React from "react";
import Row from "./row";
import * as Style from "./hero.css";

export default () => (
  <Row classNames={[Style.hero]}>
    <h1 className={Style.logo}>Mormorsmor</h1>
  </Row>
);
